import { render, staticRenderFns } from "./SimpleJsonTree.vue?vue&type=template&id=31f05837&scoped=true&"
import script from "./SimpleJsonTree.vue?vue&type=script&lang=js&"
export * from "./SimpleJsonTree.vue?vue&type=script&lang=js&"
import style0 from "./SimpleJsonTree.vue?vue&type=style&index=0&id=31f05837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f05837",
  null
  
)

export default component.exports